import { customerInformationFormFactory } from 'factories'
import * as React from 'react'

type Setter = (key: string, val: string) => void

interface CustomerInformationFormDebugOptions {
  populateDependencies: { formSetter: Setter }
  setErrorDependencies: {
    formErrorSetter: React.Dispatch<React.SetStateAction<any>>
  }
}

export const getDebugOperations = ({
  populateDependencies,
  setErrorDependencies,
}: CustomerInformationFormDebugOptions) => ({
  populate: () => {
    const inputs = customerInformationFormFactory.build()
    Object.keys(inputs).forEach((key) =>
      populateDependencies.formSetter(key, (inputs as any)[key])
    )
  },
  setError: (name: string, value: string) => {
    setErrorDependencies.formErrorSetter({ [name]: value })
  },
})
